import { render } from "./GalleryItemCard.vue?vue&type=template&id=0ec91bb6&scoped=true"
import script from "./GalleryItemCard.vue?vue&type=script&lang=js"
export * from "./GalleryItemCard.vue?vue&type=script&lang=js"

import "./GalleryItemCard.vue?vue&type=style&index=0&id=0ec91bb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec91bb6"]])

export default __exports__